import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IStepChangeEvent } from '@covalent/core/steps';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType, ITdDynamicElementValidator } from '@covalent/dynamic-forms';
import { KwEstimateComponent } from '../kw-estimate/kw-estimate.component';
import { NoCityComponent } from '../no-city/no-city.component';
import { ResultComponent } from '../result/result.component';
import { MatSliderChange } from '@angular/material'
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TranslateService } from '@ngx-translate/core';

import * as _ from 'lodash';
import * as pueblos from "../../assets/data/pueblos.json";
import * as packages from "../../assets/data/packages.json";
import * as batteryData from "../../assets/data/batteries.json";
import * as studyFields from "../../assets/data/studyFields.json";
import * as educationSet from "../../assets/data/education.json";
import { ApiService } from '../api.service';

@Component({
  selector: 'app-loan-quote',
  templateUrl: './loan-quote.component.html',
  styleUrls: ['./loan-quote.component.css']
})
export class LoanQuoteComponent{
  @ViewChild('step1', {static: false}) step1;

  // declarations
  contactForm: FormGroup;
  personalForm: FormGroup;
  financialForm: FormGroup;
  energyForm: FormGroup;
  requestForm: FormGroup;
  hasUnitNumber: boolean = false;
  isLoading: boolean = false;
  checkQuoteStatus: any;
  installAddressSame: boolean = true;

  kws: any = [
   { name: "January",    kws: 25  },
   { name: "February",   kws: 25  },
   { name: "March",      kws: 25  },
   { name: "April",      kws: 25  },
   { name: "May",        kws: 25  },
   { name: "June",       kws: 25  },
   { name: "July",       kws: 25  },
   { name: "August",     kws: 25  },
   { name: "September",  kws: 25  },
   { name: "October",    kws: 25  },
   { name: "November",   kws: 25  },
   { name: "December",   kws: 25  },
  ];

  package: any = _.find(packages.default, 'default');
  packages: any = packages.default;
  fields: any = studyFields.default;
  education: any = educationSet.default;
  batteries: number = 0;
  batteryEval: any;

  // constants
  cities = pueblos.default;
  states = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AS", label: "American Samoa" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "DC", label: "District Of Columbia" },
    { value: "FM", label: "Federated States Of Micronesia" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "GU", label: "Guam" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MH", label: "Marshall Islands" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "MP", label: "Northern Mariana Islands" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PW", label: "Palau" },
    { value: "PA", label: "Pennsylvania" },
    { value: "PR", label: "Puerto Rico" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VI", label: "Virgin Islands" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" }
  ];
  maritalStatuses = ['SINGLE', 'MARRIED'];

  constructor(
    private fb: FormBuilder,
    private api: ApiService,
    public kwEstimateDialog: MatDialog,
    public noCityDialog: MatDialog,
    public resultDialog: MatDialog,
    public translate: TranslateService
  ) {
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('en');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|es/) ? browserLang : 'en');
  }
  
  ngOnInit(): void {
    console.log(this.package);
    console.log(this.packages);
    // contact information
    this.contactForm = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      address: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['PR', [Validators.required]],
      zip_code: ['', [Validators.required, Validators.minLength(5)]],
      postal_address: ['', []],
      postal_city: ['', []],
      postal_state: ['', []],
      postal_zip_code: ['', []],
      email: ['', [Validators.required, Validators.email]],
      phone_number: ['', [Validators.required]],
    });


    // personal information
    this.personalForm = this.fb.group({
      marital_status: ['', [Validators.required] ],
      birthday: ['', [Validators.required] ],
      ssn: ['', [Validators.required] ],
      native_puerto_rican: [true, [] ],
      education_level: ['', [] ],
      year: [(new Date()).getFullYear(), [Validators.minLength(4), Validators.maxLength(4)] ],
      study_field: ['', [] ],
    })


    // financial information
    this.financialForm = this.fb.group({
      estimated_fico: ['', [Validators.min(0)] ],
      total_assets: ['', [Validators.min(0)] ],
      salary: ['', [Validators.min(0)] ],
      work_industry: ['', [Validators.required] ],
      no_of_dependents: [0, [Validators.min(0)] ],
    })

    // energy needs
    this.energyForm = this.fb.group({
      kws: [5, [Validators.min(0), Validators.max(25)] ],
      batteries: [0, [Validators.min(0)] ],
      package: [this.package, [Validators.required]]
    })

    this.watchFormChanges();
  }

  // page functions
  switchLanguage(language: string) {
    this.translate.use(language);
  }

  help() {
    var city = this.contactForm.get("city").value;
    if (city) {
      const kwDialogRef = this.kwEstimateDialog.open(
        KwEstimateComponent,
        {
          data: { 
            pueblo: this.contactForm.get("city").value, 
            kws: this.kws,
            // package: this.package,
            package: this.energyForm.get('package').value,
          }
        });

      kwDialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.data.hasOwnProperty('capacityReal')) {
            this.energyForm.get("kws").setValue(result.data.capacityReal.toFixed(2));
          }
          if (result.data.hasOwnProperty('package')) {
            // this.package = result.data.package;
            this.energyForm.get('package').setValue(result.data.package);
          }
        }
      });
    } else {
      
      const noCityDialogRef = this.noCityDialog.open(NoCityComponent);

      noCityDialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (result.data.hasOwnProperty('pickCity')) {
            if (result.data['pickCity'] === true) {
              // open step 1 of the stepper
              this.step1.open();
            }
          }
        }
      });
    }
    
  }


  submitForm(form: any) {
    // console.log(form);
  }

  onSameAddressChange(val: any) {
    var address = this.contactForm.get('postal_address');
    var city = this.contactForm.get('postal_city');
    var state = this.contactForm.get('postal_state');
    var zip_code = this.contactForm.get('postal_zip_code');

    if (val === false) {
      address.setValidators([Validators.required]);
      city.setValidators([Validators.required]);
      state.setValidators([Validators.required]);
      zip_code.setValidators([Validators.required]);
    } else {
      address.reset();
      address.clearValidators();
      address.updateValueAndValidity();
      city.reset();
      city.clearValidators();
      city.updateValueAndValidity();
      state.reset();
      state.clearValidators();
      state.updateValueAndValidity();
      zip_code.reset();
      zip_code.clearValidators();
      zip_code.updateValueAndValidity();
    }
  }

  watchFormChanges() {
    // watch for kW changes
    this.energyForm.get('kws').valueChanges.subscribe(
      kws => {
        // do something when KWs changes
      }
    )
  }

  change(event: IStepChangeEvent): void {
    // console.log(event);
  };

  onBatteryChange(event: MatSliderChange) {
    this.batteries = event.value;
    this.batteryEval = this.getBatteryEval(this.batteries*10);
  }

  getBatteryEval(kwh: number) {
    return _.find(batteryData.default, { kwh: kwh });
  }

  conditionalValidator(predicate, validator) {
    return (formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (predicate()) {
        return validator(formControl); 
      }
      return null;
    })
  }

  requiredIfValidator(predicate) {
    return (formControl => {
      if (!formControl.parent) {
        return null;
      }
      if (predicate()) {
        return Validators.required(formControl); 
      }
      return null;
    })
  }

  next(form: any, thisStep: any, nextStep: any): void {
    thisStep.state = (form.valid && !form.pristine ? "complete" : "required");
    nextStep.toggle();
  }

  reset(form: any): void {
    form.reset();
  }

  cancel(): void {
    // maybe reset the form..?
  }

  requestQuote(): void {
    var request = {
      applicant: {
        // contactForm
        first_name: this.contactForm.get('first_name').value,
        last_name: this.contactForm.get('last_name').value,
        phone_number: this.contactForm.get('phone_number').value,
        email: this.contactForm.get('email').value,
        // installation address
        installation_address: this.contactForm.get('address').value,
        installation_city: this.contactForm.get('city').value,
        installation_state: this.contactForm.get('state').value,
        installation_zip_code: this.contactForm.get('zip_code').value,
        // postal address
        postal_address: (this.installAddressSame === true ? this.contactForm.get('address').value : this.contactForm.get('postal_address').value ),
        postal_city: (this.installAddressSame === true ? this.contactForm.get('city').value : this.contactForm.get('postal_city').value ),
        postal_state: (this.installAddressSame === true ? this.contactForm.get('state').value : this.contactForm.get('postal_state').value ),
        postal_zip_code: (this.installAddressSame === true ? this.contactForm.get('zip_code').value : this.contactForm.get('postal_zip_code').value ),

        // personalForm
        martial_status: this.personalForm.get('marital_status').value,
        birthday: this.personalForm.get('birthday').value,
        ssn: this.personalForm.get('ssn').value,
        native_puerto_rican: this.personalForm.get('native_puerto_rican').value,
        education_level: this.personalForm.get('education_level').value,
        study_field: this.personalForm.get('study_field').value,
        year_graduated: this.personalForm.get('year').value,

        // financialForm
        estimated_fico: this.financialForm.get('estimated_fico').value,
        no_of_dependents: this.financialForm.get('no_of_dependents').value,
        salary: this.financialForm.get('salary').value,
        work_industry: this.financialForm.get('work_industry').value,
        total_assets: this.financialForm.get('total_assets').value,

        // energyForm
        electric_kws: this.energyForm.get('kws').value,
        batteries: this.batteries,
        // package: this.package.value,
        package: this.energyForm.get('package').value.value,
      }
    }

    // console.log(request);
    
    this.isLoading = true;
    this.api.requestQuote(request)
      .subscribe(data => {
        console.log(data); // { "id": "42863b34-7ae3-4458-ad20-e8cc911c7208" }
        this.getQuote(data.id);
      });
  }

  private getQuote(id: string): any {
    this.api.getQuote(id)
      .subscribe(result => {
        console.log(['getQuote result', result]);
        this.isLoading = false;
        const resultDialogRef = this.resultDialog.open(ResultComponent, { data: result });
      });
  }
}
